/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './index.scss';
import APIEndpoints from '../../../api/APIEndpoints';
import { axiosInstance } from '../../../../api/axios';
import { CLAIM_TYPES } from '../../../../constants';
import ClaimTypeFilter from './claim-type-filter';
import Skeleton from '../../common/skeleton';
import ClaimList from './claim-list';
import SelectedClaimList from '../../../api/ClaimsList';
import CustomClientError from '../../../errorhandling/CustomClientError';
import { useDispatch, useSelector } from 'react-redux';
import {
  setClaimsResult,
  setActiveUser,
  setSearchParams,
  resetSearchParams,
} from 'src/redux/admin/claimsSlice';
import moment from 'moment';
import Carousel from 'react-multi-carousel';
import { capitalizeFirstLetter } from 'src/Member/utils/strings';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1250 },
    items: 7,
  },
  desktop1: {
    breakpoint: { max: 1250, min: 1024 },
    items: 4,
  },
  desktop2: {
    breakpoint: { max: 1024, min: 900 },
    items: 4,
  },
  desktop3: {
    breakpoint: { max: 900, min: 800 },
    items: 3,
  },
  desktop4: {
    breakpoint: { max: 800, min: 576 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 576, min: 0 },
    items: 2,
  },
};

const Claims = (props) => {
  const dispatch = useDispatch();
  const { selectedMember } = useSelector((state) => state.memberModule);
  //Claim Range Configuration
  const {
    appConfigs: { Common_Setting },
  } = useSelector(({ app }) => app);
  const claimsYearRange =
    Common_Setting?.Claims_Year_Range !== undefined
      ? Common_Setting?.Claims_Year_Range
      : 5;
  const [uniqueClaimTypes, setUniqueClaimTypes] = useState(CLAIM_TYPES);

  //Fetching Claims summary
  const fetchClaimsSummary = async (oid, memType, employeeInfo) => {
    setIsNotFound(false);
    setIsAPIFailed(false);
    try {
      let claimResultSet = [];
      if (oid !== activeUserOID) {
        if (memType === 'Employee') {
          memType = 'Family';
        }
        const fromDate = new Date().getFullYear() - claimsYearRange + '-01-01';
        const toDate = moment(new Date()).format('YYYY-MM-DD');
        const claimsResponse = await axiosInstance.get(
          APIEndpoints.getClaimsListResource() +
            memType +
            '/oid/' +
            oid +
            '/AdminCenter/true' +
            '/pageSize/10000/incurreddatefrom/' +
            fromDate +
            '/incurreddateto/' +
            toDate,
        );
        claimResultSet = addingSupressConstraint(
          claimsResponse.data.Response.Claims,
        );
        claimResultSet.sort(
          (a, b) => new Date(b.ServiceDate) - new Date(a.ServiceDate),
        );
        dispatch(resetSearchParams());
        dispatch(setActiveUser({ label: memType, OID: oid }));
        dispatch(setClaimsResult(claimResultSet));
      } else {
        claimResultSet = claimsResult;
      }
      setDataFetching(false);
      setIsNotFound(false);
      setIsAPIFailed(false);
      setActiveClaim(claimCategory);
      setClaimsMasterData(getActiveUserClaims(claimResultSet, employeeInfo));
      const activeUserClaims = getActiveUserClaims(
        claimResultSet,
        employeeInfo,
        claimCategory,
      );
      setClaimsFilterdData(activeUserClaims);
    } catch (error) {
      setDataFetching(false);
      setIsAPIFailed(true);
      if (error.toString().includes('404')) {
        setIsNotFound(true);
      }
    }
  };

  const addingSupressConstraint = (claimDataLIst) => {
    const claimsListWithSupress = [];
    claimDataLIst.forEach((eachClaim, index) => {
      claimsListWithSupress.push({
        ...eachClaim,
        PatientResponsibility:
          eachClaim.DisplayPaymentInfo === 'true'
            ? eachClaim.PatientResponsibility
            : -1,
        //eachClaim.SuppressPaymentInfo === 'true'
        //? -1
        //: eachClaim.PatientResponsibility,
      });
    });
    return claimsListWithSupress;
  };

  const filterUniqueClaims = (claimsData) => {
    if (claimsData.length > 0) {
      const uniquStatusses = [...CLAIM_TYPES];
      claimsData.forEach((eachClaim) => {
        if (!uniquStatusses.includes(eachClaim.ClaimStatus)) {
          uniquStatusses.push(eachClaim.ClaimStatus);
        }
      });
      const uniquCustomizedLabels = [];
      uniquStatusses.forEach((claimStatus, index) => {
        if (
          !uniquCustomizedLabels.includes(
            capitalizeFirstLetter(claimStatus.toLocaleLowerCase()),
          )
        ) {
          uniquCustomizedLabels.push(
            capitalizeFirstLetter(claimStatus.toLocaleLowerCase()),
          );
        }
      });
      setUniqueClaimTypes(uniquCustomizedLabels);
    }
  };

  const getActiveUserClaims = (
    masterData,
    employeeInfo,
    claimCategory = null,
  ) => {
    //Need to remove condition for family
    if (
      props.selectedUser?.label.startsWith('Family (') ||
      selectedMember?.label.startsWith('Family (')
    ) {
      if (claimCategory == null) {
        return masterData;
      } else {
        let filteredRecords = [];
        if (claimCategory === 'All claims') {
          filteredRecords = masterData;
        } else if (claimCategory === 'Last claims') {
          masterData.forEach((eachClaim, index) => {
            if (index < 5) {
              filteredRecords.push(eachClaim);
            }
          });
        } else {
          filteredRecords = masterData.filter(
            (eachClaim) =>
              eachClaim.ClaimStatus.toLowerCase() ===
              claimCategory.toLowerCase(),
          );
        }
        return filteredRecords;
      }
    }
    let patientName = '';
    employeeInfo.forEach((ele) => {
      if (ele.OID === props.userOID) {
        patientName = ele.fullname;
      }
    });
    if (claimCategory == null) {
      //const masterList = masterData.filter( eachRecord => eachRecord.PatientName.toLowerCase() === patientName.toLocaleLowerCase() );
      const masterList = masterData.filter((eachRecord) => {
        const memberORDependentOID = Object.prototype.hasOwnProperty.call(
          eachRecord,
          'DependentOid',
        )
          ? eachRecord.DependentOid
          : eachRecord.MemberOid;
        return memberORDependentOID === props.userOID;
      });
      return masterList;
    } else {
      let filteredRecords = [];
      //const subMasterList = masterData.filter( eachRecord => eachRecord.PatientName.toLowerCase() === patientName.toLowerCase() );
      const subMasterList = masterData.filter((eachRecord) => {
        const memberORDependentOID = Object.prototype.hasOwnProperty.call(
          eachRecord,
          'DependentOid',
        )
          ? eachRecord.DependentOid
          : eachRecord.MemberOid;
        return memberORDependentOID === props.userOID;
      });
      if (claimCategory === 'All claims') {
        filteredRecords = subMasterList;
      } else if (claimCategory === 'Last claims') {
        subMasterList.forEach((eachClaim, index) => {
          if (index < 5) {
            filteredRecords.push(eachClaim);
          }
        });
      } else {
        filteredRecords = subMasterList.filter(
          (eachClaim) =>
            eachClaim.ClaimStatus.toLowerCase() === claimCategory.toLowerCase(),
        );
      }
      return filteredRecords;
    }
  };

  const activeClaimTypeCount = (claimType) => {
    if (claimType === 'All claims') {
      return claimsMasterData?.length;
    } else if (claimType === 'Last claims') {
      return claimsMasterData?.length >= 5 ? 5 : claimsMasterData?.length;
    }
    if (claimsMasterData?.length) {
      return claimsMasterData.filter(
        (eachClaim) =>
          eachClaim.ClaimStatus.toLowerCase() === claimType.toLowerCase(),
      ).length;
    } else {
      return claimsMasterData?.length;
    }
  };

  const filterDataByClaimType = (claimType) => {
    let filteredRecords = [];
    if (claimType === 'All claims') {
      filteredRecords = claimsMasterData;
    } else if (claimType === 'Last claims') {
      claimsMasterData.forEach((eachClaim, index) => {
        if (index < 5) {
          filteredRecords.push(eachClaim);
        }
      });
    } else {
      filteredRecords = claimsMasterData.filter(
        (eachClaim) =>
          eachClaim.ClaimStatus.toLowerCase() === claimType.toLowerCase(),
      );
    }
    setClaimsFilterdData(filteredRecords);
  };

  const claimClickHanler = (claimType) => {
    if (claimType !== undefined) {
      setActiveClaim(claimType);
      if (claimCategory !== claimType) {
        dispatch(resetSearchParams());
        dispatch(setSearchParams({ claimCategory: claimType }));
      }
      filterDataByClaimType(claimType);
    }
  };

  const { userOID, memberType } = props;

  const {
    searchParms: { claimCategory },
    claimsResult,
    activeUserOID,
  } = useSelector(({ claims }) => claims);

  useEffect(() => {
    claimClickHanler(claimCategory);
  }, [claimCategory]);
  //Claims Master Data and Filtered Data
  const [claimsMasterData, setClaimsMasterData] = useState([]);
  const [claimsFilterdData, setClaimsFilterdData] = useState([]);
  const [activeClaim, setActiveClaim] = useState(claimCategory);
  //const [ activeOID, setActiveOID ] = useState( userOID )
  const [isNotFound, setIsNotFound] = useState(false);

  //These are for data fetching and if API Fails
  const [dataFetching, setDataFetching] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);

  useEffect(() => {
    setActiveClaim(claimCategory);
  }, [claimCategory]);

  useEffect(() => {
    if (claimsMasterData?.length > 0) {
      filterUniqueClaims(claimsMasterData);
    }
  }, [claimsMasterData]);
  //const { searchProviderParams: { Network }, address, networksList } = useSelector( ( { findProvider } ) => findProvider );
  const { memberList } = useSelector(({ memberModule }) => memberModule);
  useEffect(() => {
    setIsNotFound(false);
    setDataFetching(true);
    if (memberList.length > 0) {
      fetchClaimsSummary(props.userOID, props.memberType, memberList);
    }
  }, [props.userOID, memberList, props.selectedUser]);

  return (
    <>
      <div className="claims-info">
        {isAPIFailed ? (
          <div className="container-offset">
            {isNotFound ? (
              <CustomClientError
                ErrorHeading="No claims found!"
                ErrorMessage="The selected Member does not have any claims."
              />
            ) : (
              <CustomClientError
                ErrorHeading="Something went wrong with request!"
                ErrorMessage="Please try again."
              />
            )}
          </div>
        ) : (
          <>
            <div className="claims-header-filters mt-3 container-offset">
              <Col className="">
                <div className="carousel-container p-0">
                  <div className="carousel-wrapper">
                    <div className="d-flex each-claim-type-filter">
                      {
                        <Carousel
                          additionalTransfrom={0}
                          arrows
                          shouldResetAutoplay={false}
                          centerMode={false}
                          className=""
                          containerClass="container-with-dots"
                          dotListClass=""
                          draggable
                          focusOnSelect={false}
                          infinite={false}
                          keyBoardControl
                          minimumTouchDrag={80}
                          renderButtonGroupOutside={false}
                          renderDotsOutside={false}
                          itemClass="slider-image-item"
                          responsive={responsive}
                        >
                          {!dataFetching
                            ? uniqueClaimTypes.map((eachType, index) => {
                                return (
                                  <ClaimTypeFilter
                                    key={`each-claim-${index}`}
                                    claimLabel={eachType}
                                    isActive={
                                      eachType === activeClaim
                                        ? 'active-claim'
                                        : ''
                                    }
                                    recordCount={activeClaimTypeCount(eachType)}
                                    claimClickHanler={claimClickHanler}
                                  />
                                );
                              })
                            : [1, 2, 3, 4, 5, 6, 7].map((item) => (
                                <Skeleton key={item} width={120} height={25} />
                              ))}
                        </Carousel>
                      }
                    </div>
                  </div>
                </div>
              </Col>
            </div>
            <ClaimList
              claimDataList={claimsFilterdData}
              dataFetching={dataFetching}
              isAPIFailed={isAPIFailed}
              preserveData={props.preserveData}
              selectedUserFirstName={props.selectedUserFirstName}
              selectedUserEmail={props.selectedUserEmail}
              userOID={props.userOID}
              memberType={props.memberType}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Claims;
